import React from 'react'

function About() {
    return (
        <React.Fragment>
            <h1>About</h1>
            <p>This is the TodoList app v1.0.0 React learning</p>
        </React.Fragment>
    )
}

export default About;